<template>
  <div :class="hasWebp ? 'raas' : 'raas noWebp'">
    <div class="raas_box raas_main">
      <div class="raas_inner">
        <div class="raas_main_banner">
          <div class="raas_main_blt">
            <div class="rs_title">无需经验，无需团队，无需货源!<div></div>从0到1的跨境零售模式<div></div>——全球云店</div>
            <div class="rs_sub">自己就能做跨境电商，多对一专家服务，保姆式培训，投入少、启动快，全球云店助力中国卖家全球带货！</div>
            <div class="raas_main_link" @click="goIntroduce">
              <span>全球云店业务介绍</span>
              <img class="link_icon" src="../../static/imgs/xiangxiagengduo.svg" alt="">
              <img class="link_icon_hover" src="../../static/imgs/xiangxiagengduo2.svg" alt="">
            </div>
          </div>
          <div class="raas_main_brt">
            <img v-if="hasWebp" src="../../static/imgs/raas_main_1.webp" alt="">
            <img v-else src="../../static/imgs/raas_main_1.png" alt="">
          </div>
        </div>
        <A-Button text='立即联系开店经理' class="rs_button" style="margin-right: 40px;" @onclick="openOrder"></A-Button>
        <A-Button text='领取跨境卖家攻略' class="rs_button rs_button_tran" @onclick="openOrder"></A-Button>
      </div>
    </div>
    <div class="raas_box raas_market">
      <div class="raas_inner">
        <div class="rs_title">解决跨境电商难点，率先赢战全球市场</div>
        <em class="rs_title_line"></em>
        <div class="rs_bottom">
          <div class="rs_market_item rsm_left">
            <div class="rs_market_title">跨境电商痛点</div>
            <div class="rs_market_res"><em></em>不清楚海外消费习惯很难精准把握商机</div>
            <div class="rs_market_res"><em></em>平台规则复杂，投入大，风险大</div>
            <div class="rs_market_res"><em></em>推广成本高精准流量获取难</div>
            <div class="rs_market_res"><em></em>不懂运营怎么快速盈利</div>
            <div class="rs_market_res"><em></em>跨境管理遇挑战难以降本增效稳定出单</div>
            <div class="rs_market_res"><em></em>店铺效果不好不知道如何改善优化</div>
          </div>
          <div class="rs_market_item rsm_right">
            <div class="rs_market_title">全球云店</div>
            <div class="rs_market_res"><img src="../assets/correct.svg" alt=""/>行业洞察报告、找准大方向</div>
            <div class="rs_market_res"><img src="../assets/correct.svg" alt=""/>全球可见的智能云店铺</div>
            <div class="rs_market_res"><img src="../assets/correct.svg" alt=""/>基础设施建设，SaaS服务，全球物流，全球仓储服务</div>
            <div class="rs_market_res"><img src="../assets/correct.svg" alt=""/>百位资深营销顾问全程陪伴式服务</div>
            <div class="rs_market_res"><img src="../assets/correct.svg" alt=""/>全链路营销服务，以销售效果为导向</div>
            <div class="rs_market_res"><img src="../assets/correct.svg" alt=""/>全渠道智能管理锁定营收</div>
            <div class="rs_market_res"><img src="../assets/correct.svg" alt=""/>全链路数据支持，从数据采集，分析，行动，真正做到数据驱动型增长</div>
            <div class="rs_market_res"><img src="../assets/correct.svg" alt=""/>风控指导、资金合规、安全稳定长期盈利</div>
          </div>
        </div>
      </div>
    </div>
    <div class="raas_box raas_sevice">
      <div class="raas_inner">
        <div class="rs_title white">跨境零售首选全球云店</div>
        <em class="rs_title_line"></em>
        <div class="rs_bottom">
          <div class="rs_sevice_item">
            <div class="rs_sevice_item_title">
              <img src="../assets/1.svg" alt="1."/>整合品牌需求
            </div>
            <div class="re_sevice_item_res">专属市场洞察团队<br>沟通产品以及市场</div>
          </div>
          <div class="rs_sevice_item">
            <div class="rs_sevice_item_title">
              <img src="../assets/2.svg" alt="2."/>店铺搭建
            </div>
            <div class="re_sevice_item_res">符合全球网购习惯的<br>完美店铺</div>
          </div>
          <div class="rs_sevice_item">
            <div class="rs_sevice_item_title">
              <img src="../assets/3.svg" alt="3."/>全链路营销服务
            </div>
            <div class="re_sevice_item_res">营销专家定制营销全案<br>配套无忧成长培训计划</div>
          </div>
          <div class="rs_sevice_item">
            <div class="rs_sevice_item_title">
              <img src="../assets/4.svg" alt="4."/>运营&履约协作
            </div>
            <div class="re_sevice_item_res">长期运营工作配合<br>数据分析形成认知迭代</div>
          </div>
        </div>
        <A-Button text='立即免费体验' class="rs_button" @onclick="openOrder"></A-Button>
      </div>
    </div>
    <div class="raas_box raas_system">
      <div class="raas_inner">
        <div class="rs_title">全球云店<br>开通即开张</div>
        <em class="rs_title_line"></em>
        <div class="rs_bottom">
          <div class="rs_system_item">
            <img src="../../static/imgs/raas_system_1.svg" alt="">
            <div class="rs_system_item_rt">
              <div class="rs_system_item_title">全球云店</div>
              <div class="re_system_item_res"><em></em>无需设计团队</div>
              <div class="re_system_item_res"><em></em>无需研发团队</div>
              <div class="re_system_item_res"><em></em>全球消费者爱逛爱购物的网店</div>
              <div class="re_system_item_res"><em></em>自带不可外传的蓝海商品库，商机掌握在少数人手中</div>
            </div>
          </div>
          <div class="rs_system_item">
            <img src="../../static/imgs/raas_system_2.svg" alt="">
            <div class="rs_system_item_rt">
              <div class="rs_system_item_title">多渠道精准引流</div>
              <div class="re_system_item_res"><em></em>投放师人均10年投放经验，过亿美金的投放金额</div>
              <div class="re_system_item_res"><em></em>主流媒体渠道聚焦，全渠道流量覆盖</div>
              <div class="re_system_item_res"><em></em>人群精准投放，没有人比我们更懂人群</div>
              <div class="re_system_item_res"><em></em>营销策划方案+帮投+投放培训</div>
            </div>
          </div>
          <div class="rs_system_item">
            <img src="../../static/imgs/raas_system_3.svg" alt="">
            <div class="rs_system_item_rt">
              <div class="rs_system_item_title">可视化数据洞察</div>
              <div class="re_system_item_res"><em></em>多渠道经营数据统计</div>
              <div class="re_system_item_res"><em></em>精准人群数据统计，根据人群数据选品，投广告</div>
              <div class="re_system_item_res"><em></em>将数据转化为可行动的结论优化店铺运营</div>
            </div>
          </div>
          <div class="rs_system_item">
            <img src="../../static/imgs/raas_system_4.svg" alt="">
            <div class="rs_system_item_rt">
              <div class="rs_system_item_title">品牌运营</div>
              <div class="re_system_item_res"><em></em>产品品牌定位</div>
              <div class="re_system_item_res"><em></em>活动策划</div>
              <div class="re_system_item_res"><em></em>管家式运营帮扶</div>
              <div class="re_system_item_res"><em></em>解决所有跨境难题</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="raas_box raas_why">
      <div class="raas_inner">
        <div class="rs_title white">为什么全球云店是跨境零售的首选？</div>
        <div class="rs_sub">用户多、政策好、流量大的电商平台；<br>一个月开门迎客，两个月生意成型，三个月稳定增长！</div>
      </div>
    </div>
    <div class="raas_box raas_build">
      <div class="raas_inner">
        <div class="rs_build_box">
          <div class="rs_title">全球云店快速开通，全球带货即刻开张</div>
          <em class="rs_title_line"></em>
          <div class="rs_build_box_bottom">
            <div class="rsbb_item">
              <div class="rsbb_item_left">
                <img src="../../static/imgs/raas_build_1.png" alt="">
              </div>
              <div class="rsbb_item_right">
                <div class="rsbb_item_title"><span>符合外国人消费习惯</span>的店铺设计</div>
                <div class="rsbb_item_res"><em></em>来自阿里巴巴设计团队，提供专业视觉方案</div>
                <div class="rsbb_item_res"><em></em>全类目定制化搭建店铺</div>
                <div class="rsbb_item_res"><em></em>特殊域名抢注，稀有域名抢购</div>
              </div>
            </div>
            <div class="rsbb_item reverse">
              <div class="rsbb_item_left">
                <img src="../../static/imgs/raas_build_2.png" alt="">
              </div>
              <div class="rsbb_item_right">
                <div class="rsbb_item_title">强大的<span>基础设施和店铺系统</span></div>
                <div class="rsbb_item_res"><em></em>稳定安全的后台系统，高效管理店铺</div>
                <div class="rsbb_item_res"><em></em>支持全球收款，对接50+种支付方式</div>
                <div class="rsbb_item_res"><em></em>对接完整物流系统，低价、便捷、安全</div>
              </div>
            </div>
          </div>
        </div>
        <div class="rs_build_box2">
          <div class="rs_title">多对一导师式服务</div>
          <em class="rs_title_line"></em>
          <div class="rs_build_box_bottom2">
            <div class="rsbb_item">
              <div class="rsbb_item_left">
                <img src="../../static/imgs/raas_build_3.svg" alt="">
              </div>
              <div class="rsbb_item_right">
                <div class="rsbb_item_title">基于消费者和供应链大数据的<span>选品服务</span></div>
                <div class="rsbb_item_res"><em></em>基于全球最大的电商数据库的大量数据选品</div>
                <div class="rsbb_item_res"><em></em>每周一份定制选品报告</div>
                <div class="rsbb_item_res"><em></em>全程陪伴式初阶、中高阶选品培训</div>
              </div>
            </div>
            <div class="rsbb_item reverse">
              <div class="rsbb_item_left">
                <img src="../../static/imgs/raas_build_4.svg" alt="">
              </div>
              <div class="rsbb_item_right">
                <div class="rsbb_item_title">以销量转化率为导向的<span>广告投放服务</span></div>
                <div class="rsbb_item_res"><em></em>千亿级流量+百位优化师营销加持 加速直接精准客户</div>
                <div class="rsbb_item_res"><em></em>广告账户搭建、创意设计营销、专属增长运营</div>
                <div class="rsbb_item_res"><em></em>广告效果诊断以及优化建议</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="raas_box raas_training">
      <div class="raas_inner">
        <div class="rs_title white">全球云店卖家培训</div>
        <em class="rs_title_line"></em>
        <div class="raas_training_bar">
          <div><em class="rs_tb_point"><em></em></em>跨境电商底层逻辑</div>
          <div><em class="rs_tb_point"><em></em></em>选品定价策略</div>
          <div><em class="rs_tb_point"><em></em></em>海外广告营销</div>
          <div><em class="rs_tb_point"><em></em></em>社交媒体运营</div>
          <div><em class="rs_tb_point"><em></em></em>电商后台实操</div>
        </div>
        <div class="rs_bottom">
          <div class="raas_training_item">
            <img src="../../static/imgs/raas_train_1.svg" alt="">
            <div class="raas_training_item_text">系统专家操作培训</div>
          </div>
          <div class="raas_training_item">
            <img src="../../static/imgs/raas_train_2.svg" alt="">
            <div class="raas_training_item_text">设计专家店铺搭建</div>
          </div>
          <div class="raas_training_item">
            <img src="../../static/imgs/raas_train_3.svg" alt="">
            <div class="raas_training_item_text">选品专家进阶突破</div>
          </div>
          <div class="raas_training_item">
            <img src="../../static/imgs/raas_train_4.svg" alt="">
            <div class="raas_training_item_text">广告专家投放课程</div>
          </div>
          <div class="raas_training_item">
            <img src="../../static/imgs/raas_train_5.svg" alt="">
            <div class="raas_training_item_text">Facebook广告基础操作培训</div>
          </div>
          <div class="raas_training_item">
            <img src="../../static/imgs/raas_train_6.svg" alt="">
            <div class="raas_training_item_text">Facebook广告优化逻辑培训</div>
          </div>
        </div>
      </div>
    </div>
    <div class="raas_box raas_case">
      <div class="raas_inner">
        <div class="rs_title">全球云店的成功卖家</div>
        <em class="rs_title_line"></em>
        <div class="rs_bar">
          <div :class="tabId === index ? 'rs_tab rs_tab_active' : 'rs_tab'" v-for="(item, index) in tabData" :key="index" @click="tabId = index" @mouseenter="tabId = index">{{item.title}}</div>
        </div>
        <div :class="tabId === index ? 'rs_case_bottom rs_case_bottom_active':'rs_case_bottom'" v-for="(item, index) in tabData" :key="index">
          <div class="rsc_title"><img class="rsc_icon" :src="item.icon" alt="">{{item.user}}</div>
          <div class="rsc_res1">{{item.des1}}</div>
          <div class="rsc_res2">{{item.des2}}</div>
          <img class="rsc_img" :src="mbFlag ? item.mimg:item.img" alt="">
        </div>
      </div>
    </div>
    <FooterCN></FooterCN>
    <Sidebanner :openOrder="isOpenOrder"></Sidebanner>
  </div>
</template>

<script>
import FooterCN from './common/footerCNNew.vue';
import Sidebanner from './common/sidebanner.vue'
export default {
  name:'solution-raas',
  components:{
    FooterCN,
    Sidebanner
  },
  props: ['hasWebp'],
  data(){
    return{
      tabData: [
        {
          title: "李先生",
          icon: "../../static/imgs/raas_case_icon_1.svg",
          user: "李先生-淘宝卖家：",
          des1: "“全球云店招商经理联系我，当时就很感兴趣，疫情导致国内市场一蹶不振，海外国家的消费品市场已经全面复苏了，所以跨境电商的机会回来了。",
          img: "../../static/imgs/raas_case_1.png",
          mimg: "../../static/imgs/raas_case_m1.png",
          des2: "他们帮助我调研市场，推荐选品，开通全球云店，又快又省事，遇到问题就能找到专家解决。师傅领进门，修行靠个人，我相信今年营业额能冲刺1000万美金！”",
        },
        {
          title: "张老板",
          icon: "../../static/imgs/raas_case_icon_2.svg",
          user: "张老板-义乌小商品经销商：",
          des1: "“从业10年一直做黑人兄弟生意，锅碗瓢盆日用品，曾经生意很好做。 2020年疫情以来，进货的朋友明显变少了，咱就研究自己卖，学习了几个跨境电商的销售办法，英文看不懂，政策规则太难太复杂了。",
          img: "../../static/imgs/raas_case_2.png",
          mimg: "../../static/imgs/raas_case_m2.png",
          des2: "去年开通全球云店，直接把商品零售给非洲朋友，半年营业额200万美金，比以前出货量还大！正准备再开几家店铺，多卖几个类目！”",
        },
        {
          title: "Jason",
          icon: "../../static/imgs/raas_case_icon_3.svg",
          user: "jason-亚马逊卖家：",
          des1: "“2015年就开始做跨境电商了，2018年巅峰时期一个季度2000w美金营业额，结果遇上疫情一蹶不振，物流价格暴涨，亚马逊强制要求入海外仓，外汇监管，封店...凭本事赚的钱，市场环境下又亏回去了。",
          img: "../../static/imgs/raas_case_3.png",
          mimg: "../../static/imgs/raas_case_m3.png",
          des2: "开通全球云店一年多，整体效益已经和原有业务持平了，继续跟着政策方向，走出去做自己的生意！”",
        },
        {
          title: "林总",
          icon: "../../static/imgs/raas_case_icon_4.svg",
          user: "林总-中国知名茶叶品牌创始人：",
          des1: "“线下卖了20年，淘宝卖了10年，茶制品行业我的品牌已经全国前三了！全球云店的负责人来公司喝茶，聊到品牌出海，正合我意。从市场调研，数据分析，网站搭建，商品运营，营销推广，支付结汇，几乎所有事都是他们在做，让我又省钱又省心。",
          img: "../../static/imgs/raas_case_4.png",
          mimg: "../../static/imgs/raas_case_m4.png",
          des2: "现在我们品牌已经在东欧和东亚卖火了，正在和全球云店开发北美和英国市场，我也和立顿掰掰手腕，分一块全球茶制品的市场份额！“",
        },
        {
          title: "张女士",
          icon: "../../static/imgs/raas_case_icon_5.svg",
          user: "张女士-个人创业者：",
          des1: "“生完宝宝以后在家做全职太太，孩子4岁上幼儿园了，有点空余时间。结婚前做过淘宝运营，现在也没办法全职上班，听说国内电商内卷严重，机会太少了。当年和老公去欧洲度蜜月的经历让我决定尝试跨境电商，看过亚马逊和其他平台的政策，发现风险太大，资金要求高，还需要专业运营人员，完全不适合我自己做生意。",
          img: "../../static/imgs/raas_case_5.png",
          mimg: "../../static/imgs/raas_case_m5.png",
          des2: "大学同学给我推荐了全球云店，投入小，回款快，效率高。我经营大半年了，一个人，一台电脑，通过全球云店就能把商品源源不断的卖给外国人，目前我的网站20000美金/月的营业额，利润5000美金，比上班挣得多！”",
        },
      ],
      tabId: 0,
      mbFlag: false,
      isOpenOrder: false,
    }
  },
  methods:{
    goIntroduce() {
      window.open('/cn/detail?p=21406&from=blog')
    },
    consult(){
      if (window.Tawk_API) {
        window.Tawk_API.maximize();
      }
      return
      if (window.fcWidget.isLoaded()) {
        window.fcWidget.open()
      }
    },
    openOrder() {
      this.isOpenOrder = true;
      setTimeout(() => {
        this.isOpenOrder = false;
      }, 500);
    }
  },
  created(){
    document.title = '全球云店——想法即商业，开店即开张';;
    if (window.innerWidth < 767) {
      this.mbFlag = true;
    }
  },
}
</script>
<style scoped>
  .raas {
    width: 100%;
  }
  .raas_box {
    width: 100%;
  }
  .raas_inner {
    width: 1200px;
    margin: 0 auto;
    padding: 80px 0;
  }
  .rs_title {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 44px;
    color: #222536;
    letter-spacing: 0.61px;
    line-height: 46px;
    font-weight: 700;
  }
  .rs_sub {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 36px;
    color: #FFFFFF;
    letter-spacing: 0.5px;
    line-height: 46px;
    font-weight: 700;
    margin-top: 40px;
  }
  .rs_button {
    padding: 0 68px;
    height: 58px;
    border-radius: 8px;
    font-family: SourceHanSansCN-Medium !important;
    font-size: 24px;
    line-height: 56px;
    color: #FFFFFF;
    font-weight: 500;
    /* background: #FB5421; */
    box-shadow: 0px 6px 16px 0px rgba(251,84,33,0.33);
  }
  .rs_button_tran {
    background: rgba(251,84,33,0.15);
    border: 1.5px solid rgba(251,84,33,0.85);
    box-shadow: 0px 6px 16px 0px rgba(255,144,85,0.26);
    border-radius: 8px;
    line-height: 53px;
    backdrop-filter: blur(10px);
  }
  .rs_button_tran:hover {
    background: rgba(251,84,33,0.30);
    border: 1.5px solid rgba(251,84,33,0.85);
    box-shadow: 0px 6px 16px 0px rgba(255,144,85,0.26);
    border-radius: 8px;
  }
  .rs_title_line {
    display: inline-block;
    width: 60px;
    height: 8px;
    background: #FC5421;
    border-radius: 6px;
    margin-top: 34px;
  }
  .rs_bottom {
    display: flex;
    flex-wrap: wrap;
    margin-top: 55px;
    justify-content: space-between;
  }
  .white {
    color: #FFFFFF;
  }
  .reverse {
    flex-direction: row-reverse;
  }

  .raas_main {
    background: url("../../static/imgs/raas_bg_main.png") center/cover,
    #02021D;
  }
  .raas_main .raas_inner {
    padding: 142px 0 179px;
  }
  .raas_main_banner {
    display: flex;
    justify-content: space-between;
    margin-bottom: 36px;
  }
  .raas_main_blt {
    
  }
  .raas_main_link {
    display: flex;
    align-items: center;
    font-family: SourceHanSansCN-Bold;
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 2.67px;
    font-weight: 700;
    cursor: pointer;
    margin-top: 20px;
    width: fit-content;
  }
  .raas_main_link img{
    margin-left: 12px;
  }
  .raas_main_link:hover{
    color: #FC5322;
  }
  .raas_main_link:hover .link_icon_hover{
    display: block;
  }
  .raas_main_link:hover .link_icon,
  .raas_main_link .link_icon_hover{
    display: none;
  }
  .raas_main .rs_title {
    font-size: 40px;
    color: #FFFFFF;
    letter-spacing: 3.67x;
    line-height: 60px;
    white-space: nowrap;
  }
  .raas_main .rs_sub {
    font-size: 24px;
    line-height: 42px;
    letter-spacing: 2.33px;
    font-weight: 500;
    /* white-space: nowrap; */
    color: #D7DCE9;
    margin-top: 50px;
  }
  .raas_main_brt {
    margin-left: 0px;
  }
  .raas_main_brt img {
    width: 547px;
    /* height: 348px; */
    margin-top: -20px;
  }

  .raas_market {
    text-align: center;
  }
  .rs_market_item {
    width: 580px;
    padding: 48px;
    border-radius: 2px;
    text-align: left;
  }
  .rsm_left {
    background: rgba(80,92,104,0.03);
    border: 2px solid rgba(34,36,54,0.12);
  }
  .rsm_right {
    background: #222536;
    border-radius: 2px;
    color: #FFFFFF;
  }
  .rs_market_title {
    font-family: Helvetica-Bold;
    font-size: 36px;
    letter-spacing: 0.5px;
    line-height: 48px;
    font-weight: 700;
    margin-bottom: 44px;
  }
  .rsm_left .rs_market_title {
    color: #222536;
  }
  .rs_market_res {
    position: relative;
    font-family: Helvetica;
    font-size: 24px;
    letter-spacing: 0.33px;
    line-height: 36px;
    font-weight: 400;
  }
  .rs_market_res + .rs_market_res {
    margin-top: 32px;
  }
  .rsm_left .rs_market_res {
    margin-left: 36px;
    color: #505C68;
  }
  .rsm_right .rs_market_res {
    margin-left: 40px;
  }
  .rs_market_res img {
    position: absolute;
    width: 25px;
    top: 5px;
    left: -38px;
  }
  .rs_market_res em {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #505C68;
    position: absolute;
    left: -30px;
    top: 10px;
  }

  .raas_sevice {
    background: url("../../static/imgs/raas_bg_sevice.png") center/cover;
    text-align: center;
  }
  .raas_sevice .rs_bottom {
    margin-bottom: 29px;
  }
  .rs_sevice_item {
    width: 288px;
    height: 193px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .rs_sevice_item_title {
    display: inline-block;
    font-family: SourceHanSansCN-Bold !important;
    font-size: 28px;
    color: #FFFFFF;
    line-height: 28px;
    font-weight: 700;
  }
  .rs_sevice_item_title img {
    width: 33px;
    vertical-align: text-bottom;
    margin-right: 8px;
  }
  .re_sevice_item_res {
    margin-top: 25px;
    font-family: SourceHanSansCN-Regular !important;
    font-size: 22px;
    color: #D3D5E0;
    line-height: 26px;
    font-weight: 400;
  }

  .raas_system {
    background: #FFFFFF;
  }
  .raas_system .raas_inner {
    text-align: center;
  }
  .raas_system .rs_title {
    line-height: 56px;
  }
  .rs_system_item {
    width: 580px;
    height: 262px;
    background: #FFFFFF;
    display: flex;
    align-items: flex-start;
    margin-bottom: 13px;
    text-align: left;
  }
  .rs_system_item img {
    width: 100px;
    min-width: 100px;
    margin-right: 25px;
    margin-top: 20px;
    border-radius: 50%;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
  }
  .rs_system_item_rt {
  }
  .rs_system_item_title {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 28px;
    color: #222536;
    font-weight: 700;
    margin-top: 27px;
    margin-bottom: 23px;
  }
  .re_system_item_res {
    font-family: SourceHanSansCN-Regular !important;
    font-size: 18px;
    color: #505C68;
    letter-spacing: 0.62px;
    line-height: 20px;
    position: relative;
    margin-left: 20px;
  }
  .re_system_item_res + .re_system_item_res {
    margin-top: 18px;
  }
  .re_system_item_res em {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #FF6032;
    position: absolute;
    left: -20px;
    top: 2px;
  }

  .raas_why {
    background: url("../../static/imgs/raas_bg_solution.png") center/cover;
    text-align: center;
  }

  .raas_build {
    text-align: center;
  }
  .rs_build_box {
    margin-top: -10px;
  }
  .rs_build_box2 {
    margin-top: 105px;
  }
  .rs_build_box_bottom {
    margin-top: 78px;
  }
  .rs_build_box_bottom2 {
    margin-top: 67px;
  }
  .rsbb_item {
    display: flex;
    justify-content: space-between;
  }
  .rsbb_item + .rsbb_item {
    margin-top: 80px;
  }
  .rs_build_box .rsbb_item_left img {
    width: 688px;
    height: 375px;
    box-shadow: 0 4px 20px 0 rgba(0,0,0,0.10);
  }
  .rsbb_item_right {
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .rsbb_item_title {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 32px;

    letter-spacing: 0;
    line-height: 28px;
    font-weight: 700;
    margin-bottom: 48px;
  }
  .rsbb_item_title span {
    color: #FC5322;
  }
  .rsbb_item_res {
    font-family: SourceHanSansCN-Regular !important;
    font-size: 22px;
    color: #505C68;
    letter-spacing: 0;
    font-weight: 400;
    display: flex;
  }
  .rsbb_item_res + .rsbb_item_res {
    margin-top: 25px;
  }
  .rsbb_item_res em {
    display: inline-block;
    width: 12px;
    min-width: 12px;
    height: 12px;
    background: #FC5322;
    border-radius: 50%;
    margin-right: 12px;
    margin-top: 8px;
  }

  .raas_training {
    background: url("../../static/imgs/raas_bg_train.png") center/cover;
    text-align: center;
  }
  .raas_training_bar {
    padding: 26px 25px;
    display: flex;
    justify-content: space-between;
  }
  .raas_training_bar div {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 28px;
    color: #FFFFFF;
    letter-spacing: 0.39px;
    font-weight: 700;
    display: flex;
    align-items: center;
  }
  .rs_tb_point {
    display: inline-block;
    border: 1px solid #FFFFFF;
    border-radius: 50%;
    margin-right: 10.5px;
    height: fit-content;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .rs_tb_point em {
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background-color: #fff;
    margin: 4px;
  }
  .raas_training .rs_bottom{
    margin-top: 5px;
  }
  .raas_training_item {
    width: 380px;
    height: 285px;
    background: #FFFFFF;
    border-radius: 5px;
    margin-top: 35px;
  }
  .raas_training_item img {
    width: 100%;
  }
  .raas_training_item_text {
    font-family: SourceHanSansCN-Medium !important;
    font-size: 24px;
    color: #222536;
    letter-spacing: 0;
    font-weight: 500;
    margin-top: 24px;
  }

  .rs_bar {
    width: 1200px;
    background: #FFEDE7;
    box-shadow: 0px 3px 6px 0px rgba(99,18,0,0.08);
    border-radius: 83px;
    display: flex;
    margin-top: 55px;
    overflow: hidden;
    z-index: 10;
  }
  .rs_bar div {
    font-family: SourceHanSansCN-Bold !important;
    font-size: 28px;
    color: #222536;
    letter-spacing: 0.39px;
    text-align: center;
    font-weight: 700;
    padding: 26px 49px;
    white-space: nowrap;
  }
  .raas_case {
    text-align: center;
    position: relative;
  }
  .raas_case .rs_bar {
    position: absolute;
    top: 159px;
    cursor: pointer;
  }

  .rs_tab {
    padding: 26px 44px !important;
    flex: 1;
  }
  /* .rs_tab:last-child {
    text-align: left;
  } */
  .rs_tab:hover ,.rs_tab_active {
    background-image: linear-gradient(180deg, #FE8B47 0%, #FC5322 100%);
    color: #FFFFFF !important;
  }
  .rs_case_bottom {
    display: none;
    width: 1209px;
    min-height: 768px;
    margin: 116px auto 0;
    padding: 40px 46px;
    background-image: linear-gradient(180deg, #FFFBFA 0%, #FDF5F2 100%);
    z-index: -1;
    text-align: left;
  }
  .rs_case_bottom_active {
    display: block;
  }
  .rsc_title {
    font-family: SourceHanSansCN-Medium !important;
    font-size: 24px;
    color: #222536;
    letter-spacing: 0;
    font-weight: 500;
  }
  .rsc_icon {
    vertical-align: text-bottom;
    margin-right: 10px;
  }
  .rsc_res1, .rsc_res2 {
    font-family: SourceHanSansCN-Regular !important;
    font-size: 20px;
    color: #505C68;
    letter-spacing: 0;
    line-height: 32px;
    font-weight: 400;
    margin-top: 13px;
    font-weight: bold;
  }
  .rsc_res2 {
    color: #FC5421;
    font-weight: 700;
  }
  .rsc_img {
    width: calc(100% + 46px);
    margin-top: 40px;
    margin: 40px -46px -40px 0;
  }

 @media (max-width: 767px) {
    .raas {
      margin-top: 1.6rem;
    }
    .raas_inner {
      width: 100%;
      padding: .75rem 0.48rem .75rem;
    }
    .rs_title {
      font-size: .4rem;
      letter-spacing: 0.0056rem;
      line-height: .56rem;
      font-weight: 700;
    }
    .rs_sub {
      font-size: .28rem;
      letter-spacing: 0.0039rem;
      line-height: .46rem;
      margin-top: .45rem;
    }
    .rs_button {
      width: 100%;
      height: fit-content;
      text-align: center;
      padding: .2rem .8rem;
      border-radius: .08rem;
      font-size: .3rem;
      line-height: .3rem;
      letter-spacing: .0273rem;
      margin-right: 0 !important;
      box-shadow: 0 .06rem .16rem 0 rgba(251,84,33,0.33);
    }
    .rs_button + .rs_button {
      margin-top: .32rem;
    }
    .rs_button_tran {
      border: .015rem solid rgba(251,84,33,0.85);
      box-shadow: 0 .02rem .16rem 0 rgba(255,144,85,0.26);
    }
    .rs_button_tran:hover {
      background: rgba(251,84,33,0.30);
    }
    .rs_title_line {
      width: .6rem;
      height: .08rem;
      border-radius: .06rem;
      margin-top: .3rem;
    }
    .rs_bottom {
      margin-top: .55rem;
    }
    .white {
      color: #FFFFFF;
    }
    .reverse {
      flex-direction: column;
    }

    .raas_main {
      background: url("../../static/imgs/raas_mbg_main.webp") center/cover, #02021D;
    }
    .noWebp .raas_main {
      background: url("../../static/imgs/raas_mbg_main.png") center/cover, #02021D;
    }
    .raas_main .raas_inner {
      padding: 1rem 0.48rem .9rem;
    }
    .raas_main_banner {
      flex-direction: column;
      margin-bottom: .56rem;
    }
    .raas_main_link {
      font-size: .28rem;
      letter-spacing: .0267rem;
      margin-top: .2rem;
    }
    .raas_main_link img{
      margin-left: .12rem;
      height: .24rem;
    }
    .raas_main_blt {

    }
    .raas_main .rs_title {
      font-size: .45rem;
      letter-spacing: .0375rem;
      line-height: .58rem;
      white-space: normal;
    }
    .raas_main .rs_title div{
      display: none;
    }
    .raas_main .rs_sub {
      font-size: .28rem;
      letter-spacing: 0.018rem;
      line-height: .32rem;
      font-weight: 400;
      margin-top: .45rem;
      margin-bottom: 0;
    }
    .raas_main_brt {
      margin-left: 0;
      width: 100%;
    }
    .raas_main_brt img {
      width: 100%;
      height: auto;
      margin-top: .56rem;
    }

    .raas_market {
      text-align: center;
    }
    .rs_market_item {
      width: 100%;
      padding: .48rem .48rem .85rem;
      border-radius: .02rem;
    }
    .rs_market_item + .rs_market_item {
      margin-top: .35rem;
    }
    .rsm_left {
      border: .02rem solid rgba(34,36,54,0.12);
    }
    .rsm_right {
      border-radius: .02rem;
    }
    .rs_market_title {
      font-size: .36rem;
      letter-spacing: .005rem;
      line-height: .48rem;
      font-weight: 600;
      margin-bottom: .44rem;
    }
    .rs_market_res {
      font-size: .24rem;
      letter-spacing: 0.0033rem;
      line-height: .36rem;
    }
    .rs_market_res + .rs_market_res {
      margin-top: .32rem;
    }
    .rsm_left .rs_market_res {
      margin-left: .36rem;
    }
    .rsm_right .rs_market_res {
      margin-left: .4rem;
    }
    .rs_market_res img {
      width: .25rem;
      top: .05rem;
      left: -.38rem;
    }
    .rs_market_res em {
      width: .12rem;
      height: .12rem;
      left: -.3rem;
      top: .1rem;
    }

    .raas_sevice .rs_bottom {
      margin-top: 0.17rem;
      margin-bottom: 0;
    }
    .rs_sevice_item {
      width: 3.08rem;
      height: 1.93rem;
    }
    .rs_sevice_item_title {
      font-size: .32rem;
      line-height: .28rem;
    }
    .rs_sevice_item_title img {
      width: .33rem;
      margin-right: .08rem;
    }
    .re_sevice_item_res {
      margin-top: .25rem;
      font-size: .24rem;
      line-height: .3rem;
    }
    .raas_sevice .rs_button {
      display: none;
    }

    .raas_system .rs_title {
      line-height: .56rem;
      margin: 0 .23rem;
    }
    .rs_system_item {
      width: 100%;
      height: fit-content;
      margin-bottom: 0rem;
      text-align: left;
    }
    .rs_system_item + .rs_system_item {
      margin-top: .35rem;
    }
    .rs_system_item img {
      width: 1.05rem;
      min-width: 1.05rem;
      margin-right: .3625rem;
      margin-top: .21rem;
      border-radius: 50%;
      box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
    }
    .rs_system_item_rt {
    }
    .rs_system_item_title {
      font-size: .32rem;
      margin: .21rem 0 .265rem;
    }
    .re_system_item_res {
      font-size: .24rem;
      letter-spacing: .0075rem;
      line-height: .27rem;
      margin-left: .23rem;
    }
    .re_system_item_res + .re_system_item_res {
      margin-top: .13rem;
    }
    .re_system_item_res em {
      width: .125rem;
      height: .125rem;
      border-radius: 50%;
      left: -.23rem;
      top: .06rem;
    }

    .raas_why {
      background: url("../../static/imgs/raas_mbg_solution.png") center/cover;
    }

    .raas_build {
      text-align: center;
    }
    .rs_build_box {
      margin-top: 0;
    }
    .rs_build_box2 {
      margin-top: .76rem;
    }
    .rs_build_box_bottom {
      margin-top: .55rem;
    }
    .rs_build_box_bottom2 {
      margin-top: .55rem;
    }
    .rsbb_item {
      flex-direction: column-reverse;
    }
    .rsbb_item + .rsbb_item {
      margin-top: .6rem;
    }
    .rs_build_box .rsbb_item_left img {
      width: 100%;
      height: auto;
      box-shadow: 0 .04rem .2rem 0 rgba(0,0,0,0.10);
      margin-top: .4rem;
    }
    .rs_build_box2 .rsbb_item_left img {
      width: 100%;
      height: auto;
      margin-top: .4rem;
    }
    .rsbb_item_title {
      font-size: .34rem;
      line-height: .28rem;
      margin-bottom: .4rem;
    }
    .rsbb_item_res {
      font-size: .24rem;
      letter-spacing: .0075rem;
    }
    .rsbb_item_res + .rsbb_item_res {
      margin-top: .21rem;
    }
    .rsbb_item_res em {
      width: .12rem;
      min-width: .12rem;
      height: .12rem;
      border-radius: 50%;
      margin-right: .11rem;
      margin-top: .11rem;
    }

    .raas_training {
      background-image: radial-gradient(circle at 50% 57%, #060834 0%, #02021D 46%);
      text-align: center;
    }
    .raas_training_bar {
      padding: 0;
      flex-wrap: wrap;
      margin-top: .28rem;
    }
    .raas_training_bar div {
      font-size: .28rem;
      line-height: .84rem;
      letter-spacing: 0.0039rem;
      white-space: nowrap;
    }
    .raas_training_bar::after {
      content: "";
      width: .8rem;
    }
    .rs_tb_point {
      border: .01rem solid #FFFFFF;
      margin-right: .1rem;
    }
    .rs_tb_point em {
      width: .18rem;
      height: .18rem;
      margin: .04rem;
    }
    .raas_training .rs_bottom{
      margin-top: .1rem;
    }
    .raas_training_item {
      width: 100%;
      height: auto;
      border-radius: .05rem;
      margin-top: .35rem;
    }
    .raas_training_item img {
      width: 100%;
    }
    .raas_training_item_text {
      font-size: .34rem;
      line-height: .34rem;
      margin: .32rem 0;
    }

    .rs_bar {
      width: calc(100% - .96rem);
      box-shadow: 0 .03rem .06rem 0px rgba(99,18,0,0.08);
      border-radius: .83rem;
      margin-top: .56rem;
      overflow-x: auto;
    }
    .rs_bar div {
      font-size: .16rem;
      line-height: .16rem;
      letter-spacing: 0.0022rem;
    }
    .raas_case .rs_bar {
      top: 1.59rem;
    }
    .rs_tab {
      padding: .25rem .155rem !important;
    }
    .rs_tab:first-child {
      padding-left: .35rem !important;
    }
    .rs_tab:last-child {
      /* padding-right: .45rem !important; */
    }
    .rs_case_bottom {
      width: 100%;
      min-height: fit-content;
      margin: .73rem auto 0;
      padding: .62rem .22rem .5rem;
      background: #FDF5F2;;
      overflow: hidden;
    }
    .rsc_title {
      font-size: .24rem;
    }
    .rsc_icon {
      vertical-align: text-bottom;
      max-width: .32rem;
      max-height: .32rem;
      margin-right: .1rem;
      margin-left: -.07rem;
    }
    .rsc_res1, .rsc_res2 {
      text-indent: 1em;
      font-size: .2rem;
      line-height: .32rem;
      margin-top: .08rem;
    }
    .rsc_img {
      width: calc(100% + .54rem);
      margin: .35rem -.27rem .04rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/solutionRaas.vue